/* Not loaded on the storefront: the theme loads component-product-gallery-slider.min.js, a copy of this file. Shopify re-minifies .js assets into syntax iOS 13.0-13.3 cannot run, and serves .min.js files as they are. Make changes in component-product-gallery-slider.min.js. */
/* Product gallery — "Gallery with slider" style
   Defines <product-gallery-slider> (main slide track, arrows, drag),
   <product-gallery-thumbs> (thumbnail row, syncs with the main slider) and
   the expand lightbox opened by clicking a `.pgs-zoom-link` image
   (close button, ESC, backdrop click, arrow keys, focus trap).
   Fully independent from page-product.js / product-slider-component. */
(function () {
  "use strict";

  if (window.customElements.get("product-gallery-slider")) return;
  const CLOSE_ICON = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  const PREV_ICON = '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" focusable="false"><path d="M14 4l-7 7 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const NEXT_ICON = '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" focusable="false"><path d="M8 4l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  class GalleryLightbox {
    constructor(links, onClose) {
      this.links = links;
      this.onClose = onClose;
      this.index = 0;
      this.isOpen = false;
      this.onKeydown = this.onKeydown.bind(this);
      this.build();
    }
    build() {
      const multiple = this.links.length > 1;
      this.el = document.createElement("div");
      this.el.className = "pgs-lightbox";
      this.el.hidden = true;
      this.el.setAttribute("role", "dialog");
      this.el.setAttribute("aria-modal", "true");
      this.el.setAttribute("aria-label", "Product image viewer");
      this.el.innerHTML = '<div class="pgs-lightbox__backdrop" data-pgs-close></div>' + '<button type="button" class="pgs-lightbox__close" aria-label="Close image viewer" data-pgs-close>' + CLOSE_ICON + "</button>" + (multiple ? '<button type="button" class="pgs-lightbox__nav pgs-lightbox__prev" aria-label="Previous image">' + PREV_ICON + "</button>" : "") + '<figure class="pgs-lightbox__stage"><img class="pgs-lightbox__img" alt=""></figure>' + (multiple ? '<button type="button" class="pgs-lightbox__nav pgs-lightbox__next" aria-label="Next image">' + NEXT_ICON + "</button>" : "") + (multiple ? '<p class="pgs-lightbox__count" aria-live="polite"></p>' : "");
      this.img = this.el.querySelector(".pgs-lightbox__img");
      this.count = this.el.querySelector(".pgs-lightbox__count");
      this.closeBtn = this.el.querySelector(".pgs-lightbox__close");
      this.el.querySelectorAll("[data-pgs-close]").forEach(node => node.addEventListener("click", () => this.close()));
      const prev = this.el.querySelector(".pgs-lightbox__prev");
      const next = this.el.querySelector(".pgs-lightbox__next");
      prev && prev.addEventListener("click", () => this.show(this.index - 1));
      next && next.addEventListener("click", () => this.show(this.index + 1));
      document.body.appendChild(this.el);
    }
    show(index) {
      const count = this.links.length;
      this.index = (index % count + count) % count;
      const link = this.links[this.index];
      this.img.src = link.getAttribute("href");
      this.img.alt = link.dataset.alt || "";
      if (this.count) this.count.textContent = `${this.index + 1} / ${count}`;
    }
    open(index) {
      if (this.isOpen) return;
      this.isOpen = true;
      this.returnFocus = document.activeElement;
      this.show(index);
      this.el.hidden = false;
      document.documentElement.classList.add("pgs-lightbox-open");
      document.addEventListener("keydown", this.onKeydown, true);
      requestAnimationFrame(() => this.el.classList.add("is-open"));
      this.closeBtn.focus({
        preventScroll: true
      });
    }
    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.el.classList.remove("is-open");
      this.el.hidden = true;
      this.img.removeAttribute("src");
      document.documentElement.classList.remove("pgs-lightbox-open");
      document.removeEventListener("keydown", this.onKeydown, true);
      this.onClose && this.onClose(this.index, this.returnFocus);
    }
    onKeydown(e) {
      if (e.key === "Escape" || e.key === "Esc") {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      } else if (e.key === "ArrowLeft" && this.links.length > 1) {
        e.preventDefault();
        this.show(this.index - 1);
      } else if (e.key === "ArrowRight" && this.links.length > 1) {
        e.preventDefault();
        this.show(this.index + 1);
      } else if (e.key === "Tab") {
        // Keep focus inside the dialog while it's open.
        const focusable = Array.from(this.el.querySelectorAll("button"));
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        } else if (!this.el.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }
  class ProductGallerySlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector(".pgs-track");
      this.slides = Array.from(this.querySelectorAll(".pgs-slide"));
      this.prevBtn = this.querySelector(".pgs-prev");
      this.nextBtn = this.querySelector(".pgs-next");
      this.hiddenSlides || (this.hiddenSlides = new Map());
      this.index = 0;
      this.isDragging = false;
      this.dragStartX = 0;
      this.dragDeltaX = 0;
      this.suppressNextClick = false;
      this.prevBtn && this.prevBtn.addEventListener("click", () => this.go(this.index - 1));
      this.nextBtn && this.nextBtn.addEventListener("click", () => this.go(this.index + 1));
      this.bindDrag();
      this.bindZoom();
      this.update();
    }
    disconnectedCallback() {
      if (this.lightbox) {
        this.lightbox.close();
        this.lightbox.el.remove();
        this.lightbox = null;
      }
    }
    bindZoom() {
      this.zoomLinks = Array.from(this.querySelectorAll("[data-pgs-zoom]"));
      if (!this.zoomLinks.length || !this.track) return;
      this.track.addEventListener("click", e => {
        const link = e.target.closest("[data-pgs-zoom]");
        if (e.defaultPrevented || !link || !this.contains(link)) return;
        e.preventDefault();
        this.lightbox || (this.lightbox = new GalleryLightbox(this.zoomLinks, (index, returnFocus) => this.onLightboxClose(index, returnFocus)));
        this.lightbox.open(this.zoomLinks.indexOf(link));
      });
    }
    onLightboxClose(index, returnFocus) {
      // Leave the main slider on the image the user last viewed in the popup.
      const link = this.zoomLinks[index];
      const slideIndex = link ? this.slides.indexOf(link.closest(".pgs-slide")) : -1;
      if (slideIndex > -1 && slideIndex !== this.index) this.go(slideIndex);
      const target = link && slideIndex > -1 ? link : returnFocus;
      target && target.focus && target.focus({
        preventScroll: true
      });
    }
    go(index) {
      const count = this.slides.length;
      if (count < 1) return;
      // Loop around in both directions — next on the last slide goes to the
      // first, prev on the first slide goes to the last.
      this.index = (index % count + count) % count;
      this.update();
      this.dispatchEvent(new CustomEvent("gallery:change", {
        bubbles: true,
        detail: {
          index: this.index
        }
      }));
    }
    update() {
      if (!this.track) return;
      const selected = this.slides[this.index];
      const restoreFocus = this.slides.some((slide, index) => index !== this.index && slide.contains(document.activeElement));
      const previous = this.hiddenSlides.get(selected);
      if (previous) {
        selected.inert = previous.inert;
        if (previous.ariaHidden === null) selected.removeAttribute("aria-hidden");else selected.setAttribute("aria-hidden", previous.ariaHidden);
        this.hiddenSlides.delete(selected);
      }
      this.track.style.transform = `translateX(${this.index * -100}%)`;
      this.scrollLeft = 0;
      if (restoreFocus) {
        const controls = selected ? Array.from(selected.querySelectorAll('a[href],button,input:not([type="hidden"]),select,textarea,iframe,video[controls],audio[controls],[tabindex]')) : [];
        const target = [...controls, this.prevBtn, this.nextBtn].find(element => element && element.tabIndex >= 0 && !element.matches(":disabled") && !element.closest('[inert],[hidden],[aria-hidden="true"]') && element.getClientRects().length && getComputedStyle(element).visibility !== "hidden");
        target === null || target === void 0 || target.focus({
          preventScroll: true
        });
      }
      this.slides.forEach((slide, index) => {
        if (index === this.index) return;
        if (!this.hiddenSlides.has(slide)) this.hiddenSlides.set(slide, {
          inert: slide.inert,
          ariaHidden: slide.getAttribute("aria-hidden")
        });
        slide.inert = true;
        slide.setAttribute("aria-hidden", "true");
      });
    }
    bindDrag() {
      if (!this.track) return;

      // A real drag shouldn't also open the lightbox underneath the
      // pointer once the user releases — swallow the click that follows it.
      this.track.addEventListener("click", e => {
        if (!this.suppressNextClick) return;
        this.suppressNextClick = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
      if (this.slides.length < 2) return;
      const start = clientX => {
        this.isDragging = true;
        this.dragStartX = clientX;
        this.dragDeltaX = 0;
        this.track.classList.add("is-dragging");
      };
      const move = clientX => {
        if (!this.isDragging) return;
        this.dragDeltaX = clientX - this.dragStartX;
        this.track.style.transform = `translateX(calc(${this.index * -100}% + ${this.dragDeltaX}px))`;
      };
      const end = () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.track.classList.remove("is-dragging");
        if (Math.abs(this.dragDeltaX) > 5) this.suppressNextClick = true;
        const threshold = this.clientWidth * 0.15;
        if (this.dragDeltaX > threshold) {
          this.go(this.index - 1);
        } else if (this.dragDeltaX < -threshold) {
          this.go(this.index + 1);
        } else {
          this.update();
        }
        this.dragDeltaX = 0;
      };
      this.track.addEventListener("pointerdown", e => {
        if (e.pointerType === "mouse" && e.button !== 0) return;
        if (e.target.closest(".pgs-nav")) return;
        start(e.clientX);
      });
      this.track.addEventListener("pointermove", e => move(e.clientX));
      this.track.addEventListener("pointerup", end);
      this.track.addEventListener("pointercancel", end);
      this.track.addEventListener("pointerleave", () => this.isDragging && end());
    }
  }
  class ProductGalleryThumbs extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll(".pgs-thumb"));
      const wrapper = this.closest(".pgs");
      this.main = wrapper ? wrapper.querySelector("product-gallery-slider") : null;
      if (!this.main) return;
      this.buttons.forEach((btn, i) => btn.addEventListener("click", () => this.main.go(i)));
      this.main.addEventListener("gallery:change", e => this.setActive(e.detail.index));
      this.setActive(this.main.index || 0);
    }
    setActive(index) {
      this.buttons.forEach((btn, i) => {
        btn.classList.toggle("is-active", i === index);
        if (i === index) btn.setAttribute("aria-current", "true");else btn.removeAttribute("aria-current");
      });
      const active = this.buttons[index];
      active && active.scrollIntoView && active.scrollIntoView({
        behavior: "smooth",
        inline: "nearest",
        block: "nearest"
      });
    }
  }
  window.customElements.define("product-gallery-slider", ProductGallerySlider);
  window.customElements.define("product-gallery-thumbs", ProductGalleryThumbs);
})();
